<section
  class="toast-outlet"
  [attr.aria-live]="hasErrorNotifications() ? 'assertive' : 'polite'"
  aria-atomic="true"
>
  @for (notification of toast.notifications(); track notification.id) {
    <article
      class="toast"
      [class.toast--success]="notification.type === 'success'"
      [class.toast--error]="notification.type === 'error'"
      [class.toast--warning]="notification.type === 'warning'"
      [class.toast--info]="notification.type === 'info'"
      [class.toast--repeated]="notification.repeatCount > 1"
      [attr.role]="notification.type === 'error' ? 'alert' : 'status'"
    >
      <div class="toast__icon-wrap" aria-hidden="true">
        <mat-icon class="toast__icon">{{
          iconFor(notification.type)
        }}</mat-icon>
      </div>
      <div class="toast__content">
        <p class="toast__label">{{ labelFor(notification.type) }}</p>
        <p class="toast__message">{{ notification.message }}</p>
      </div>
      @if (notification.dismissible) {
        <button
          type="button"
          mat-icon-button
          class="toast__close"
          aria-label="Close notification"
          (click)="dismiss(notification.id)"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
      <div class="toast__accent" aria-hidden="true"></div>
    </article>
  }
</section>
